import { Vertical, Texto } from '@gravitate-js/excalibrr'
import { Form, InputNumber } from 'antd'
import { getHelperText } from '../utils'
import { useFormatter } from '@/api/useFormatter'
import { getFeeTypeUnit } from '@/components/Freight/shared'
import { InvoiceDetail } from '@/api/useFreight/types'
import { TransactionDetail } from '../../columnDefs'
import { AccessorialOptionType } from '../types'

type AmountInputProps = {
  selectedAccessorial:
    | {
        feeType: string
        isPercentageBased: boolean
        accessorial: TransactionDetail | InvoiceDetail | AccessorialOptionType | undefined
      }
    | undefined
  showRateAndTotal: boolean
}

export function AmountInput({ selectedAccessorial, showRateAndTotal }: AmountInputProps) {
  const formatter = useFormatter()

  const feeTypeUnit = selectedAccessorial?.feeType ? getFeeTypeUnit(selectedAccessorial.feeType) : ' -- '
  return (
    <Vertical gap={8}>
      <Form.Item
        name='amount'
        label='Amount'
        rules={[{ required: true, message: 'Please enter an amount' }]}
        style={{ marginBottom: 0 }}
      >
        <InputNumber
          type='number'
          placeholder='Enter amount'
          addonAfter={<Texto>{selectedAccessorial?.feeType || ' -- '}</Texto>}
          min={0}
          style={{ width: '100%', flex: 1, maxWidth: 275 }}
        />
      </Form.Item>
      {showRateAndTotal && (
        <>
          <Texto appearance='hint' className='px-2'>
            {getHelperText('amount', selectedAccessorial?.isPercentageBased ?? false)}
          </Texto>
          <Vertical className='px-2'>
            <Texto>Rate</Texto>
            <Texto>
              {formatter.formatCurrency(selectedAccessorial?.accessorial?.rate ?? 0, true, 5)}/{feeTypeUnit}
            </Texto>
          </Vertical>
          <Form.Item dependencies={['amount']} noStyle>
            {({ getFieldValue }) => {
              const value = getFieldValue('amount') || 0
              return (
                <Vertical flex={2} height={'auto'} className='px-2'>
                  <Texto>Total</Texto>
                  <Texto weight='bold'>
                    {formatter.formatCurrency(value * (selectedAccessorial?.accessorial?.rate ?? 0), true, 2)}
                  </Texto>
                </Vertical>
              )
            }}
          </Form.Item>
        </>
      )}
    </Vertical>
  )
}
